import React, { useState, useContext } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import zIndex from '@mui/material/styles/zIndex'
import { AdminPortal } from 'genesis-suite/components/ToolNavigator'
import ZendeskController from 'genesis-suite/components/ZendeskController'
import { Typography, Hidden, IconButton, Box, useTheme, Link } from '@mui/material'

import MobileNav from './MobileNav'
import UserProfile from './UserProfile'
import { AuthContext } from '../contexts/AuthContext'

export default function TopNav() {
    const theme = useTheme()
    const { user, actAs } = useContext(AuthContext)
    const [open, toggleDrawer] = useState(false)

    return (
        <>
            <Box
                sx={{
                    pr: 1,
                    pl: 0.5,
                    width: '100%',
                    display: 'flex',
                    position: 'fixed',
                    alignItems: 'center',
                    zIndex: zIndex.drawer + 1,
                    bgcolor: 'grayscale.lightest',
                    justifyContent: 'space-between',
                    height: theme.custom.topNavHeight,
                }}
            >
                <Hidden mdUp implementation="js">
                    <IconButton
                        size="large"
                        color="default"
                        aria-label="Open drawer"
                        onClick={() => toggleDrawer(!open)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <MobileNav open={open} onClose={() => toggleDrawer(!open)} />
                </Hidden>
                <Link
                    sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                    component={RouterLink}
                    to={'/'}
                >
                    <AdminPortal />
                    <Typography sx={{ ml: 1, color: '#000' }} display="inline" variant="h5">
                        Admin Portal
                    </Typography>
                </Link>

                {user && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <ZendeskController userAlias={user && user.alias} />
                        <UserProfile />
                    </Box>
                )}
                {/*Shim*/}
            </Box>
            <Box sx={{ height: 50 }} />
        </>
    )
}
